import { SUPPORT_EMAIL } from './Developer';
import { MINUTE_IN_MS } from './time';
import { LEMONSQUEEZY_PLAN_INTERVALS } from 'src/types/lemonsqueezyTypes';

export const MUI_DRAWER_OVERRIDING_Z_INDEX = 1301;
// https://www.geeksforgeeks.org/react-mui-z-index/

export const EVENT_SOURCE_CONNECTION_RETRY_DELAY = 5000;
export const LEMONSQUEEZY_INITIAL_CHECKOUT_MAX_TIMEOUT_MINUTES = 3;
export const LEMONSQUEEZY_SCRIPT_ID = 'lemonsqueezy-checkout-script';
export const LEMONSQUEEZY_SCRIPT_TAG_NAME = 'script';
export const LEMONSQUEEZY_SCRIPT_SRC =
  'https://assets.lemonsqueezy.com/lemon.js';
export const LEMONSQUEEZY_SCRIPT_LOAD_EVENT = 'load';
export const LEMONSQUEEZY_PAYMENT_LOADER_TEXT_TRANSLATION_KEY =
  'lemonsqueezy_payment_loader_text';
export const LEMONSQUEEZY_PAYMENT_LOADER_SUBTEXT_TRANSLATION_KEY =
  'lemonsqueezy_payment_loader_subtext';
export const LEMONSQUEEZY_INITIAL_CHECKOUT_MAX_TIMEOUT =
  LEMONSQUEEZY_INITIAL_CHECKOUT_MAX_TIMEOUT_MINUTES * MINUTE_IN_MS; // in ms

export const LEMONSQUEEZY_BY_DEFAULT_RECURRING_INTERVAL =
  LEMONSQUEEZY_PLAN_INTERVALS.month;

export const LEMONSQUEEZY_REF_QUERY_PARAM = 'lemonsqueezy';

export const LEMONSQUEEZY_PAYMENT_DELAY_MESSAGE = `Thank you for your payment. It may take a few moments for your plan to sync. If the new plan still does not appear after a moment, we’re here to help — kindly reach out to us at ${SUPPORT_EMAIL}.`;

export const YEARLY_DISCOUNT_THRESHOLD_SEATS = 50;
export const DISCOUNTED_PRO_YEARLY_PRICE = 120; // in USD per seat/year

export const LEMONSQUEEZY_PAYMENT_GUIDE_FOR_USERS = [
  {
    heading: `Don't refresh the page:`,
    description: `If you're subscribing or changing your plan, do not refresh the page during the process.`,
  },
  {
    heading: 'Pop-up Blocker Issue:',
    description:
      "If you see a pop-up blocker notification during the checkout process, please allow pop-ups for the first time. This is a one-time process, and you won't need to do it again for future transactions.",
  },
  {
    heading: 'Support:',
    description: `If you encounter any issues during the payment process, please contact our support team for assistance at ${SUPPORT_EMAIL}.`,
  },
];

export const SUBSCRIPTION_UPDATE_MESSAGE =
  'Your subscription was updated successfully.';
export const SUBSCRIPTION_CREATE_MESSAGE =
  'Your subscription was created successfully.';
export const SUBSCRIPTION_RESUME_MESSAGE =
  'Your subscription was resumed successfully.';

export const LEMONSQUEEZY_POLLING_INTERVAL = 5000; //in ms

export const CANCELLED_PLAN_NOTIFICATION_MESSAGE =
  'You already cancelled the plan. Paid plans continue until the end of the paid billing cycle.';

export const PAID_PLAN_CANCELLED_MESSAGE =
  'Paid plan cancelled successfully. The existing subscription will continue until the end of the paid billing cycle.';

export const PAID_PLAN_CANCELLED_MESSAGE_IN_PAST_DUE =
  'Paid plan cancelled successfully.';

export const LEMONSQUEEZY_PAYMENT_FAILURE_MESSAGE =
  'Something went wrong during the payment process. Additional steps might be needed to complete the payment. Please check your email inbox for any instructions from Lemonsqueezy.';

export const LEMONSQUEEZY_INITIAL_CHECKOUT_FAILURE_MESSAGE =
  'We did not receive payment updates from LemonSqueezy. If you have already made the payment, please try closing this message. If you have not made the payment, please retry the checkout process.';

export const LEMONSQUEEZY_CHECKOUT_WINDOW_OPEN_FAILURE_MESSAGE =
  'Unable to open the payment window. Please allow pop-ups and try again.';

export const LEMONSQUEEZY_CHECKOUT_OVERLAY_UNAVAILABLE_MESSAGE =
  'We could not start the checkout overlay. Please refresh the page and try again.';
export const LEMONSQUEEZY_CHECKOUT_BASE_URL =
  process.env.REACT_APP_LEMONSQUEEZY_CHECKOUT_BASE_URL;

if (!LEMONSQUEEZY_CHECKOUT_BASE_URL) {
  throw new Error(
    'REACT_APP_LEMONSQUEEZY_CHECKOUT_BASE_URL is missing or empty. Please set the environment variable.',
  );
}

export const LEMONSQUEEZY_CHECKOUT_QUANTITY_PARAM_KEY = 'quantity';
export const LEMONSQUEEZY_CHECKOUT_CUSTOM_ORG_ID_KEY =
  'checkout[custom][organization_id]';
export const LEMONSQUEEZY_CHECKOUT_DISCOUNT_CODE_PARAM_KEY =
  'checkout[discount_code]';
export const LEMONSQUEEZY_CHECKOUT_OVERLAY_ENABLED = true;
export const SELECTED_PLAN_INVALID_MESSAGE = 'selected plan is invalid';

export const SELECTED_RECURRING_INTERVAL_MESSAGE =
  'selected recurring interval';

export const PURCHASED_SEATS_INVALID_MESSAGE = 'purchased seats is invalid';

export const TOTAL_AMOUNT_FOR_BILLING_PERIOD = (interval: string) =>
  `Total amount for ${interval} billing period in USD (excluding tax & proration will apply)`;

export const MINIMUM_SEAT_COUNT = 1;
export const LEMONSQUEEZY_EXISTING_SUBSCRIPTION_UPDATE_FAILURE_MESSAGE =
  'Something went wrong while updating your subscription. If the issue persists, please visit our troubleshooting guide.';

export const LEMONSQUEEZY_PAYMENT_TROUBLESHOOTING_LINK =
  'https://docs.hanabot.ai/docs/troubleshooting/payment-troubleshooting';

export const NO_INVOICES_TO_SHOW_MESSAGE = 'There are no invoices to show.';
